export function formatTimestampToDate(ts: string): string {
    const date = new Date(Number(ts))
    const dformat =
        [date.getFullYear(), date.getMonth() + 1, date.getDate()].join('-') +
        ' ' +
        [
            date.getHours()?.toString()?.length === 1 ? `0${date.getHours()}` : date.getHours(),
            date.getMinutes()?.toString()?.length === 1 ? `0${date.getMinutes()}` : date.getMinutes()
        ].join(':')

    return dformat
}
